$(document).ready(function () {
  if (!$(".sorted_variants input[name='Package Size']:checked").val()) {
    $(".product__info-wrapper .product-form__submit").addClass("disabled_btn");
  } else {
    $(".product__info-wrapper .product-form__submit").removeClass(
      "disabled_btn"
    );
  }
  $(".sorted_variants input[name='Package Size']").change(function () {
    $(".product__info-wrapper .product-form__submit").removeClass(
      "disabled_btn"
    );
  });
  jQuery(".tab-btn").click(function () {
    var id_tab = jQuery(this).attr("data-val");
    jQuery(".tab-btn").removeClass("active");
    jQuery(this).addClass("active");

    jQuery(".product-tab-body").removeClass("active");
    jQuery(".product-tab-body." + id_tab).addClass("active");
  });

  setTimeout(function () {
    $(".banner-slider-area").owlCarousel({
      margin: 0,
      loop: true,
      autoHeight: true,
      slideSpeed: 3000,
      paginationSpeed: 400,
      autoplay: true,
      nav: true,
      pagination: false,
      dots: false,
      navText: [
        "<img src='https://cdn.shopify.com/s/files/1/0695/5922/2515/t/1/assets/previous.png'>",
        "<img src='https://cdn.shopify.com/s/files/1/0695/5922/2515/t/1/assets/next.png'>",
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        700: {
          items: 1,
        },
        1000: {
          items: 1,
        },
        1100: {
          items: 1,
        },
      },
    });
  }, 500);
  setTimeout(function () {
    $(".feature-slider").owlCarousel({
      margin: 30,
      loop: true,
      slideSpeed: 3000,
      paginationSpeed: 400,
      // autoplay:true,
      nav: true,
      pagination: false,
      dots: false,
      navText: [
        "<img src='https://cdn.shopify.com/s/files/1/0727/6449/0038/files/Vector_36.png?v=1709277065'>",
        "<img src='https://cdn.shopify.com/s/files/1/0727/6449/0038/files/Vector_38.png?v=1709277097'>",
      ],
      responsive: {
        0: {
          items: 2,
        },
        480: {
          items: 2,
        },
        768: {
          items: 3,
        },
        1000: {
          items: 3,
        },
        1100: {
          items: 5,
        },
      },
    });
  }, 1000);
  setTimeout(function () {
    $("#customer_reviews").owlCarousel({
      margin: 30,
      loop: true,
      autoHeight: false,
      autoHeightClass: "owl-height",
      slideSpeed: 3000,
      paginationSpeed: 400,
      autoplay: true,
      center: true,
      nav: false,
      pagination: false,
      dots: false,
      navText: [
        "<i class='fa fa-angle-left'></i>",
        "<i class='fa fa-angle-right'></i>",
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        700: {
          items: 2,
        },
        1000: {
          items: 2,
        },
        1100: {
          items: 4,
        },
      },
    });
  }, 1500);
});

// faq JS

$(document).ready(function () {
  jQuery(".accordion-heading").click(function (e) {
    if (!$(this).closest(".accordion-box").hasClass("open")) {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    } else {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
});

function yes() {
  x = document.getElementsByClassName("shipping-address");
  x[0].style.display = "none";
}
function no() {
  x = document.getElementsByClassName("shipping-address");
  x[0].style.display = "block";
}
